import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { CerbaAuthService, IUserTransformationCompteWebServiceClient, ProfilValideDto } from "@digicerba/common";
import { Observable } from "rxjs/Rx";

@Injectable()
export class ProfilValideResolver implements Resolve<ProfilValideDto> {

  constructor(private iUserInformationsWebServiceClient: IUserTransformationCompteWebServiceClient, private cerbaAuthService: CerbaAuthService) {
  }

  resolve() {
    return this.iUserInformationsWebServiceClient.profilValide().catch(response => {
      this.cerbaAuthService.unauthorized(response.status);
      return Observable.of(new ProfilValideDto());
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/profil-valide.resolver.ts